/**
 * Created by thuongtranv1 on 5/18/2016.
 */


import { Injectable } from '@angular/core';
// import '../../../../environment.js';
import { environment } from '../../../environments/environment';
@Injectable()
export class BaseUrl {
  /* public static get BASE_URL(): string { return "http://192.168.169.212/local"; }*/
  // public static get BASE_URL(): string { return "http://192.168.169.212/local"; }
  // public static get BASE_URL(): string { return "http://nuget.harveynash.vn:6969"; }
  public static get BASE_URL(): string { return environment.resourceServer; }
  public static get AUTH_URL(): string { return environment.authConfig.authority; }
  public static get AUTH_CONFIG(): any { return environment.authConfig; }
  public static get APP_URL(): string { return environment.appUrl; }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/base.url.ts